import { consoleApi, useOpsContext } from '@nx/state';
import { isNonEmptyString } from '@nx/stdlib';
import { skipToken } from '@reduxjs/toolkit/query';

/**
 * Retrieves the full instance object for the currently selected instance in the ops context.
 * Utilizes `consoleApi` to fetch data, leveraging RTK Query's cache when the instance
 * is already loaded (e.g. by `useInstanceSelectorProps`).
 */
export function useSelectedInstance() {
  const { selectedInstanceId } = useOpsContext();
  const instance = consoleApi.useGetInstanceQuery(
    isNonEmptyString(selectedInstanceId) ? selectedInstanceId : skipToken,
  );
  return instance.data;
}
